export default {
  cake: {
    137: '0xcE492630eD77EEaf5d78E4C35eE0Ff308A5e5A1f'
  },
  masterChef: {
    137: '0xCDc9897fbb2E5C2E696BAfCFEEc912AbC89952f5',
  },
  weth: {
    137: "0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619"
  },
  lottery: {
    56: '',
    97: '',
  },
  lotteryNFT: {
    56: '',
    97: '',
  },
  mulltiCall: {
    137: '0xF236781222020F936DFdAae1dC417387E4281448'
  },
  usdc: {
    137: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174'
  },
  wmatic: {
    137: '0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270'
  },
  matic: {
    137: '0x0000000000000000000000000000000000001010'
  }
}
